import { Injectable } from '@angular/core';

import { CommonsConfigEnvironment, CommonsConfigEnvironmentRoutes } from '@mirage-projects/cw-models';

import { environment } from '../../../environments/environment';
import { CWEnvironmentConfiguration } from './environment-configuration';

@Injectable({ providedIn: 'root' })
export class EnvironmentConfigurationService {
    private appConfig: CWEnvironmentConfiguration = environment.configuration ?? ({} as any);

    getAppConfig(): CWEnvironmentConfiguration {
        return environment.configuration ?? ({} as any);
    }

    getCommonsConfig(): CommonsConfigEnvironment {
        const commonsConfig: CommonsConfigEnvironment = {
            publicApiUrl: this.appConfig.publicApiUrl,
            publicApiKey: this.appConfig.publicApiKey,
            baseURL: this.appConfig.baseURL,
            port: this.appConfig.port,
            isSite: this.appConfig.isSite,
            name: this.appConfig.name,
            verityHost: this.appConfig.verityHost,
            epsgServer: this.appConfig.epsgServer,
            geoidServer: this.appConfig.geoidServer,
            notifications: this.appConfig.notifications,
            status: this.appConfig.status,
            API_CONFIG_CORE: this.appConfig.API_CONFIG_CORE,
            productVersion: this.appConfig.productVersion,
            logLevel: this.appConfig.logLevel,
            verityRedirection: this.appConfig.verityRedirection,
        };
        return commonsConfig;
    }

    getExternalRoutes(): CommonsConfigEnvironmentRoutes[] | undefined {
        return this.appConfig.routing?.routes;
    }

    getEmbedRedirect(): string | undefined {
        return this.appConfig.routing?.embedRedirect;
    }
}
